export default {
  product_info: 'Infos produit',
  return: 'Retour aux options',
};
